import { rest } from 'msw';
import SchoolDistrictData from '../fixtures/input.json';
import Links from '../fixtures/menus';
const { profiles } = SchoolDistrictData;

const COOKIE_NAME = 'test-mock-login';

// This should probably move to a different file
const getCookieValue = (key) => {
    // document.cookie returns all the cookies in a single string.  It looks
    //     something like:  'foo=bar; blah=1.2341345134; eep=yuk'.
    const startStr = `${key}=`;
    const allCookies = document.cookie;
    const cookie = allCookies.split('; ').find((val) => {
        return val.startsWith(startStr);
    });

    // if the cookie was found it should look like 'foo=bar'.  Return 'bar'.
    if (typeof cookie === 'string') {
        return cookie.slice(startStr.length);
    }

    return null;
};

const getProfile = (loginOverride) => {
    if (loginOverride != null) {
        return profiles[loginOverride];
    }
    // return the first one
    return Object.values(profiles)[0];
};

export default [
    rest.get('/auth/rest/profile', (req, res, ctx) => {
        console.log('------- AUTH_REST_PROFILE MSW INTERCEPT ------- ', req.params);

        // by default, return the minshew login, but this can be overridden via a cookie
        //     named test-mock-login.  For example, if this cookie is set with a value
        //     of bob, the profile for bob will be returned (see ./fixtures/auth-profiles).
        // Note: a cookie is used here because /auth/rest/profile does not take any
        //     parameters.  (The same is true for /userProfile/menus.)  Most other
        //     endpoints take path or query parameters that can be used to control the
        //     data to return.  (See /partnerConfig/partners/:partnerBid/terms in
        //     dropdown-selection-handler.js.)
        const loginOverride = getCookieValue(COOKIE_NAME);
        const profile = getProfile(loginOverride);

        return res(ctx.status(200), ctx.json(profile));
    }),
    rest.get('/userProfile/menus', (req, res, ctx) => {
        console.log('------- MENUS MSW INTERCEPT ------- ', req.params);

        // See explanation for /auth/rest/profile above
        const loginOverride = getCookieValue(COOKIE_NAME);
        const key = loginOverride || 'minshew';
        const menus = Links[key];
        if (menus == null) {
            throw new Error(`unknown key: ${key}`);
        }
        console.log('menus', menus);

        return res(ctx.status(200), ctx.json(menus));
    }),
];
